<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="jobqueue_nbr_in_queue" [ttModel]="setting.jobqueue_nbr_in_queue" ttReadonly></tt-input>
        <tt-input ttLabel="jobqueue_nbr_finished" [ttModel]="setting.jobqueue_nbr_finished" ttReadonly></tt-input>
        <tt-input ttLabel="jobqueue_nbr_with_error" [ttModel]="setting.jobqueue_nbr_with_error" ttReadonly></tt-input>
        <tt-button ttText="jobqueuemonitor_refresh" (ttClick)="updateChanges()" [ttSpin]="updating" ttIcon="fas fa-sync"></tt-button>
    </tt-card>
</tt-page>
